/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_Pull_RequestInputs */



/**
* | output |
* | --- |
* | "the archive refused the pull request" |
*
* @param {Twda_Failed_Pull_RequestInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_pull_request = /** @type {((inputs?: Twda_Failed_Pull_RequestInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_Pull_RequestInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("l'archive a refusé la pull request")
	if (locale === "es") return /** @type {LocalizedString} */ ("el archivo rechazó la pull request")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o arquivo recusou o pull request")
	if (locale === "it") return /** @type {LocalizedString} */ ("l'archivio ha rifiutato la pull request")
	return /** @type {LocalizedString} */ ("the archive refused the pull request")
});